import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicLayout from '../layout/PublicLayout';

const PublicRoute = () => {
  return (
    <PublicLayout>
      <Outlet />
    </PublicLayout>
  );
};

export default PublicRoute;
